import React, {useState} from 'react';
import {useQuery} from "@tanstack/react-query";
import assetActivesService from "../../../../services/web/asset-actives-service.js";
import {navigateHook} from "../../../../hooks/use-navigate.js";
import {Template} from "../../../../components/template/template.jsx";
import Button from "../../../../components/button/button.jsx";
import {Card} from "../../../../components/card/card.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import projectUtils from "../../../../utils/project-utils.js";
import assetTransferService from "../../../../services/web/asset-transfer-service.js";
import SentryRow from "../../../../components/template/sentry-row.jsx";

const initialState = {
    asset: "",
    place: "",
    place_destination: "",
}
const AssetTransferForm = () => {
    const navigate = navigateHook();
    const [state, setState] = useState(initialState)
    const [placesOpt, setPlacesOpt] = useState([])
    const [place, setPlace] = useState("")
    const [assetsOpt, setAssetsOpt] = useState([])
    const save = () => {
        const formData = new FormData();

        const form = {
            asset_id: state.asset,
            asset_place_id: state.place,
            asset_place_destination_id: state.place_destination
        };

        Object.keys(form).forEach(key => {
            formData.append(key, form[key])
        });

        const response = assetTransferService.create(formData);
        response
            .then(({data}) => {

                navigateToList(data)
                projectUtils.success(true);
            })
            .catch((error) => {
                console.error(error);

                const {message} = error.response.data;

                let errMessage = message ?? "Não foi possível salvar.";
                projectUtils.swalErrorMessage("", errMessage, "Ok");
            })
    }

    const {isLoading} = useQuery({
        queryFn: () =>  assetActivesService.getAllActives().then((data) => {
            const newData = []
            data.map(d => newData.push({ value: d.id, label: d.text, asset_places_id: d.asset_places_id }));

            setAssetsOpt(newData)
            return []
        }),
        queryKey: ['actives']
    });

    const {data: placesAll} = useQuery({
        queryFn: () =>  assetActivesService.getPlaces().then(({data}) => {
            const newData = []
            data.map(d => newData.push({ value: d.id, label: d.text }));
            setPlacesOpt(newData)
            return newData
        }),
        initialData: [],
        queryKey: ['places']
    });

    const handleInputs = (id, value) => {
        if (id === "asset") {
            handleAssetChange(value?.asset_places_id)
            setState(prev => ({...prev, place: value?.asset_places_id, [id]: value?.value}));
        }else{
            setState(prev => ({...prev, [id]: value}));
        }
    }
    const handleAssetChange = (id) => {
        setPlace(placesAll.find(item => item.value === id));

        setPlacesOpt(placesAll.filter(item => item.value !== id));
    }

    const navigateToList = () => {
        let isBlank = false;
        let urlDev = `/asset-transfer`;
        navigate(urlDev, isBlank);
    }

    return (
        <Template isLoading={isLoading}>
            <Template.Header>
                <Template.Title>
                    Transferência entre locais
                </Template.Title>
            </Template.Header>

            <Template.Body>
                <Card>
                    <Card.Body>
                        <SentryRow>
                            <div className="col-span-4">
                                <SelectComponent
                                    name="asset"
                                    value={assetsOpt.find(t => t.value === state?.asset)}
                                    options={assetsOpt}
                                    label={"Ativo *"}
                                    onChange={(selected) => handleInputs("asset", selected)}
                                />
                            </div>
                            <div className="col-span-4">
                                <SelectComponent
                                    name="place"
                                    value={place}
                                    options={[]}
                                    label={"Local de origem *"}
                                    isDisabled
                                />
                            </div>
                            <div className="col-span-4">
                                <SelectComponent
                                    name="place_destination"
                                    value={placesOpt.find(t => t.value === state?.place_destination)}
                                    options={placesOpt}
                                    label={"Local de destino *"}
                                    onChange={(selected) => handleInputs("place_destination", selected?.value)}
                                />
                            </div>
                        </SentryRow>
                    </Card.Body>
                </Card>

                <Card className={"mt-2"}>
                    <Card.Body>
                        <div className="w-full flex justify-end">
                            <div className="flex gap-2">
                                <Button onClick={save} actionFeedbackType='save'>
                                    Salvar
                                </Button>
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            </Template.Body>
        </Template>
    );
};

export default AssetTransferForm;